var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    style: {
      margin: 5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(-353 -594)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(353 594)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-pause",
    "data-name": "Icon ionic-ios-pause",
    transform: "translate(376.833 615.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M12.4,24.037H9.383A.41.41,0,0,1,9,23.6V7.182a.41.41,0,0,1,.383-.432H12.4a.41.41,0,0,1,.383.432V23.6A.41.41,0,0,1,12.4,24.037Z",
    transform: "translate(-9 -6.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M24.774,24.037H21.758a.41.41,0,0,1-.383-.432V7.182a.41.41,0,0,1,.383-.432h3.016a.41.41,0,0,1,.383.432V23.6A.41.41,0,0,1,24.774,24.037Z",
    transform: "translate(-11.327 -6.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.783232e95afe2264711d56c8ba259dd0.svg";
export { ForwardRef as ReactComponent };